/* ============================================================
   CiemnaSzyba — galeria hero
   Źródło trzymało 5 zdjęć w tablicy PHOTOS + szósty slot „wgraj wideo".
   Tutaj galeria bierze product.media z Shopify (renderowane przez Liquid),
   więc slot wideo jest prawdziwym media_type == 'video', a nie atrapą,
   a właściciel podmienia zdjęcia w adminie bez dotykania kodu.
   ============================================================ */
(function () {
  "use strict";

  CS.onSection("[data-cs-gallery]", function (root) {
    var thumbs = CS.$$("[data-cs-action='thumb']", root);
    var slides = CS.$$("[data-cs-gal-slide]", root);
    if (!thumbs.length || !slides.length) return;

    var strip = thumbs[0].parentNode;
    var reduceMQ = window.matchMedia("(prefers-reduced-motion: reduce)");

    /* Na mobile miniatury są jednym przewijanym pasem, więc aktywna musi sama
       wjechać w kadr — inaczej po zmianie zdjęcia zaznaczenie zostaje poza
       ekranem. Ustawiamy scrollLeft na samym pasie, NIE scrollIntoView:
       ten drugi przewija też przodków i szarpie całą stroną.
       Na desktopie pas się nie przewija, więc warunek niżej wychodzi od razu. */
    function revealThumb(btn) {
      if (!strip || strip.scrollWidth <= strip.clientWidth + 1) return;
      var target = strip.scrollLeft
        + (btn.getBoundingClientRect().left - strip.getBoundingClientRect().left)
        - (strip.clientWidth - btn.offsetWidth) / 2;
      target = Math.max(0, Math.min(target, strip.scrollWidth - strip.clientWidth));
      if (strip.scrollTo) strip.scrollTo({ left: target, behavior: reduceMQ.matches ? "auto" : "smooth" });
      else strip.scrollLeft = target;
    }

    function show(idx) {
      slides.forEach(function (s) {
        var on = s.getAttribute("data-cs-gal-slide") === String(idx);
        s.hidden = !on;
        if (!on) {
          /* Zatrzymaj wideo przy przełączeniu — inaczej gra w ukrytym slajdzie. */
          var v = s.querySelector("video");
          if (v && !v.paused) v.pause();
        }
      });
      thumbs.forEach(function (t) {
        var on = t.getAttribute("data-cs-value") === String(idx);
        t.classList.toggle("is-selected", on);
        t.setAttribute("aria-pressed", on ? "true" : "false");
        if (on) revealThumb(t);
      });
    }

    function onClick(e) {
      var btn = e.target.closest("[data-cs-action='thumb']");
      if (!btn || !root.contains(btn)) return;
      show(btn.getAttribute("data-cs-value"));
    }

    root.addEventListener("click", onClick);
    return function () { root.removeEventListener("click", onClick); };
  });
})();
